import React from 'react';

export type Primitive = string | number | boolean | null | undefined | symbol | bigint;

export type FormValues = Record<string, unknown>;

export interface StepConfigItem {
  index: number;
  label: string;
  Icon?: React.ReactNode;
}

export type SerializeFunc = (value: unknown) => unknown;
export type DeserializeFunc = (value: unknown) => unknown;

export type CallbackFunc = (
  dependentValue: unknown,
  listenerValue: unknown,
  values: FormValues,
  groupValues?: unknown,
) => unknown;

export interface FormContextValue {
  // Raw Formik-like snapshots
  values: FormValues;
  errors: Record<string, unknown>;
  touched: Record<string, unknown>;
  initialValues: FormValues;

  // Form status and basic actions
  validate: () => Promise<unknown> | unknown;
  isSubmitting: boolean;
  isValid: boolean;
  submitForm: () => Promise<unknown> | unknown;

  // Field setters
  setFieldValue: (name: string, value: unknown) => void;
  setFieldTouched: (name: string, isTouched?: boolean, shouldValidate?: boolean) => void;
  setCustomError: (name: string, error: string | null) => void;
  setInitialValue: (name: string, value: unknown) => void;
  setValidationSchema: (name: string, schema: unknown) => void;
  setSerializeFunc: (name: string, serializeFunc: SerializeFunc | undefined) => void;
  setDeserializeFunc: (name: string, deserializeFunc: DeserializeFunc | undefined) => void;

  // Cross-field behavior
  setCallbackFunc: (
    listenerField: string,
    dependentField: string,
    callbackFunc: CallbackFunc,
  ) => void;

  // Stepper state
  currentStep: number;
  fieldStepMap: Record<string, number>;
  stepConfig: StepConfigItem[];
  setCurrentStep: (nextStep: number | ((prev: number) => number)) => void;
  setFieldStepMap: (fieldName: string, stepIndex: number) => void;
  setStepConfig: (stepIndex: number, stepLabel: string, StepIcon?: React.ReactNode) => void;
}

export const FormContext = React.createContext<FormContextValue | undefined>(undefined);

